// is-enterprise-sub-account.js
//
// Whether this session's account is a sub-account managed by an enterprise.
//
// This is the account side of "is this an enterprise sensor": an enterprise
// pushes its alerts down to every sensor its sub-accounts own, so any sensor set
// up under one of these accounts is already being watched by alerts the account
// didn't create — which is what the setup alerts/contacts review exists to
// explain.
//
// Not to be confused with scripts/is-account-enterprise.js, which asks the
// opposite question: whether this session *is* an enterprise admin looking at
// one of its sub-accounts.

// The linked enterprise's account id, or 0 when this session isn't linked to one
// (or the payload didn't say which).
export const enterpriseParentId = (user = window.currentUser) => {

  if (!user || !user.enterprise || !user.enterprise.parent) {
    return 0;
  }

  const parentId = Number(user.enterprise.parent);

  return isNaN(parentId) ? 0 : parentId;

};

// is_sub_account is the link itself, so it — not the parent id — is what decides
// this. A session can be linked without the payload naming the parent, and that
// is still an enterprise-managed account.
export default function isEnterpriseSubAccount (user = window.currentUser) {
  return Number(user && user.is_sub_account) === 1;
}
